import { render, staticRenderFns } from "./RichTextTemplate.vue?vue&type=template&id=693522f0&"
import script from "./RichTextTemplate.vue?vue&type=script&lang=ts&"
export * from "./RichTextTemplate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports